import Vue from 'vue';

import {
  addGroupingInResponseData,
  LinkCellRenderer,
  autoResize,
  ProgressBarRenderer,
  getPinnedRowData,
  MultiLinkCellRenderer
} from '@/helpers/renderHelpers';
import {
  addColIdToColumns,
  SumRows
} from '@/helpers/commonHelpers';
import gridProps from '@/gridProps';

export default {
  namespaced: true,
  state: {
    lotsCount: 0,
    columns: [],
    lots: [],
    pinnedRowData: [],
    lotStatuses: ["active", "completed"],
    listCurrencySymbolsOfLotsList: [],
    gridOptions: {
      rowGroupPanelShow: 'always',
      animateRows: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true
      },
      aggFuncs: {
        'SumRows': SumRows
      },
      components: {
        'ContractLink': LinkCellRenderer('contract_id', '/contracts/'),
        'ProgressBar': ProgressBarRenderer(),
        'SuppliersLink': MultiLinkCellRenderer('shippers', '/partners/', 'name', 'id')
      }
    },
    gridName: ''
  },
  getters: {
    gridOptions(state) {
      return {
        ...state.gridOptions,
        ...gridProps,
        onRowDataChanged() {
          if (this.rowData && this.rowData.length) {
            autoResize(this);
          } else {
            this.api && this.api.hideOverlay();
            this.api && this.api.showNoRowsOverlay();
          }
        }
      };
    },
    selectedRowsGridOptions(state) {
      return {...state.gridOptions};
    }
  },
  mutations: {
    setData(state, data) {
      if (data.data) {
        state.lots = addGroupingInResponseData(data.data.results);
        state.columns = addColIdToColumns(data.used_columns);
        //adding unique keys for 'Suppliers' column. Needed for correct row grouping
        state.columns = state.columns.map(e => {
          if (e.field && e.field === 'shippers') {
            e.keyCreator = function (params) {
              if (params) {
                return params.value.map(e => e.id).join('');
              }
            }
          }
          return e
        });
        state.lotsCount = data.data.count;
        state.pinnedRowData = getPinnedRowData(data.total, 'name', 'value');
      } else {
        state.lots = data;
        state.pinnedRowData = data;
      }
      if (data.grid_name) {
        state.gridName = data.grid_name;
      }
    }
  },
  actions: {
    loadLots(store, payLoad) {
      if (store.getters.gridOptions.api) {
        store.getters.gridOptions.api.showLoadingOverlay();
      }
      Vue.http.get('purchase/search_for_lots/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setData', data);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/purchases/lots/purchaseLots.js